module.exports = __webpack_public_path__ + "static/media/article-icon.8c72057e.svg";